import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { User, Mail, Phone, MapPin } from 'lucide-react';

const PersonalInfo = ({ formData, setFormData, editMode }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name" className="flex items-center gap-2">
          <User className="h-4 w-4" />
          Full name
        </Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          disabled={!editMode}
          className={!editMode ? 'bg-gray-50' : ''}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email" className="flex items-center gap-2">
          <Mail className="h-4 w-4" />
          Email
        </Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          disabled={!editMode}
          className={!editMode ? 'bg-gray-50' : ''}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone" className="flex items-center gap-2">
          <Phone className="h-4 w-4" />
          Phone number
        </Label>
        <Input
          id="phone"
          type="tel"
          placeholder="(555) 123-4567"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          disabled={!editMode}
          className={!editMode ? 'bg-gray-50' : ''}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="homeAddress" className="flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          Home address
        </Label>
        <Input
          id="homeAddress"
          placeholder="123 Main St, San Francisco, CA"
          value={formData.homeAddress}
          onChange={(e) => setFormData({ ...formData, homeAddress: e.target.value })}
          disabled={!editMode}
          className={!editMode ? 'bg-gray-50' : ''}
        />
      </div>
    </div>
  );
};

export default PersonalInfo;
